import React from 'react';
import TextField from '@mui/material/TextField';
import NumberFormat from 'react-number-format';
import InputAdornment from '@mui/material/InputAdornment';
import { NumberFormatCustomProps, CurrencyInputProps } from '../../types/componentsTypes/CurrencyInput.d';

const NumberFormatCustom = React.forwardRef<NumberFormat<React.FC>, NumberFormatCustomProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      displayType='input'
      decimalScale={2}
      allowNegative={false}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator='.'
      decimalSeparator=','
      isNumericString
    />
  );
});

const CurrencyInput: React.FC<CurrencyInputProps> = ({ label, value, onChange }) => (
  <TextField
    fullWidth
    label={label}
    value={value || ''}
    onChange={onChange}
    InputProps={{
      inputComponent: NumberFormatCustom as never,
      startAdornment: <InputAdornment position='start'>R$</InputAdornment>,
    }}
  />
);

export default CurrencyInput;
